import axios from "axios";
import Swal from "sweetalert2";

interface ApiError {
  message: string;
}

export const handleError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    if (error.code === "ECONNABORTED") {
      Swal.fire({
        title: "Request Timeout",
        text: "The server is taking too long to respond. Your request may still be processing. Please check back shortly.",
        icon: "warning",
      });
    } else if (error.response) {
      const errorData = error.response.data as ApiError;
      Swal.fire({
        title: "Error!",
        text: errorData.message || "Request failed",
        icon: "error",
      });
    } else {
      Swal.fire({
        title: "Connection Error",
        text: "Unable to reach the server. Please check your internet connection.",
        icon: "error",
      });
    }
  } else {
    Swal.fire({
      title: "Error!",
      text: "An unexpected error occurred",
      icon: "error",
    });
  }
};
